import React, { useState, useEffect, useRef } from 'react';
import MenuExteriorView from './MenuExteriorView';
import MenuInterierView from './MenuInterierView';
import AnimationBtn from './AnimationBtn';
import MenuSoftware from './MenuSoftware';
import Howtousenew from './Howtousenew';
import HowToUse from './HowToUse';
import FooterControl from './FooterControl';
import FooterControlMob from './FooterControlMob';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';

var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");
var mobPortrait = (mob && window.innerHeight > window.innerWidth);
var moblandscap = (mob && window.innerWidth > window.innerHeight);
var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

export const userContext = React.createContext();

var prevCounter = 0;
var nextClicked = false;
var prevClicked = false;


var buttonSeq = ['onResetMode', 'onExteriorClick', 'FrontModeClick', 'RearModeClick', 'onInterirorClick', 'onProcessorClick', 'onMemoryClick', 'onFanClick', 'onSoftwareClick', 'IAutomationClick', 'CResiliencyClick'];

const MainMenu = (props) => {
   const [expandedPanel, setExpandedPanel] = useState(false);

   const [portImg, setPortImg] = useState("./img/back_white.png");
   const [monitorPivotImg, setMonitorPivotImg] = useState("./img/pilot_white.png");
   const [monitorSwivelImg, setMonitorSwivelImg] = useState("./img/swivel_white.png");
   const [monitorHeightImg, setMonitorHeightImg] = useState("./img/height_white.png");
   const [monitorTiltImg, setMonitorTiltImg] = useState("./img/tilt_white.png");
   const [monitorColorometerImg, setMonitorColorometerImg] = useState("./img/colorometer_white.png");
   const [monitorHoodImg, setMonitorHoodImg] = useState("./img/hood_white.png");

   const [selectedButton, setSelectedButton] = useState('onResetMode');

   const handleAccordionChange = (panel) => (event, isExpanded) => {

      if (isExpanded) {
         setExpandedPanel(panel);

      } else {
         setExpandedPanel(false)
      };
      if (window.innerHeight < 860) {
         if (isExpanded == true && panel == 'panel3') {
            if (document.querySelector("#logoIntelDiv") != null) {
               if (window.mob == true && window.innerHeight < window.innerWidth) {
                  document.querySelector("#logoIntelDiv").style.position = 'initial';
                  document.querySelector("#logoIntelDiv").style.bottom = '450px';
               } else {
                  document.querySelector("#logoIntelDiv").style.position = 'initial';
               }

            }
         } else {
            if (document.querySelector("#logoIntelDiv") != null) {
               document.querySelector("#logoIntelDiv").style.position = 'fixed';
            }
         }
      } else {
         if (document.querySelector("#logoIntelDiv") != null && !window.isipad) {
            document.querySelector("#logoIntelDiv").style.position = 'fixed';
         }
      }


   };
   const [camData, setCamData] = useState("");
   var animationSwitch = window.Animation;
   var animTime = 1;
   var animTimes = 1;

   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {
            setCamData(myJson.positions);
         });
   }
   useEffect(() => {
      getData();
      window.getLangTranscript();
      animationSwitch = window.Animation;
      moblandscap = (mob && window.innerWidth > window.innerHeight);

      window.position = 'reset';
      return () => {
         return false
      }
   }, []);

   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }

      return () => {
         return false
      }

   }, [])
   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }
      return () => {
         return false
      }

   })
   const [animStoped, setanimStoped] = useState(true);

   const animComplete = () => {
      setanimStoped(true);
      var g_navEnabled = true;
   }

   if (animationSwitch == 'on') { animTime = 1000; animTimes = 2000 }
   else { animTime = 1; animTimes = 1 }

   const GotoPosInTimeNamedValue = (gotoposname, onComplete, onSample) => {

      var opt = undefined, gp = camData[gotoposname];
      if (gp.fovy && window.scene.fovy != gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      if (animationSwitch == 'off') {
         gp.time = 1
      }
      else {
         gp.time = animTime;

      }
      // if(window.isMac && !(window.mob||window.isipad)){
      //    console.log('isImac')
      //    window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4]+20, gp.time, onComplete, onSample, opt);
      // }
      if (window.mob || window.isipad) {
         window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4] + 70, gp.time, onComplete, onSample, opt);
      }
      else {
         window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4], gp.time, onComplete, onSample, opt);
      }
   }


   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x, a);
      var px2 = Math.pow(x2, a);

      return px / (px + px2);
   }

   const clearSlideSetTimeout = useRef(null);

   const sliderRangeBarUpdate = () => {
      let slider = document.getElementById("sliderRange");
      if (slider !== null) {
         slider.value = window.scene._nav.getZoomFactor();
         clearSlideSetTimeout.current = setTimeout(() => {
            slider.value = window.scene._nav.getZoomFactor()
         }, 1000);
      }
   }

   let animArray = ['TOp', 'Internal_Cover_Anim', 'Bezel', 'HDD38', 'pasted__HDD39', 'Fan_01', 'Fan_02', 'Fan_03', 'Fan_04', 'Fan_05', 'Fan_06', 'Ram_AnimRam_Anim', 'HEATSINK.004'];

   const stopAnim = () => {
      animArray.forEach(function (animName) {
         if (window.scene.animIsPlaying(animName)) window.scene.getAnim(animName).stop();
         window.scene.animPlayInTime(animName, 0, 0);
         //console.log(animName);
      });
      window.scene.clearRefine();
   }

   const reverseAll = () => {

      stopAnim();

      clearTimeout(clearSlideSetTimeout.current);

      for (let alreadySelected of document.querySelectorAll('.MuiAccordionDetails-root.active,.MuiAccordionDetails-root.select')) {
         if (alreadySelected !== null) {
            alreadySelected.classList.remove('active', 'select');
         }
      }

      for (let hotspot of document.querySelectorAll(".hotspots")) {
         if (hotspot !== null) {
            hotspot.style.display = 'none';
            hotspot.setAttribute('tabindex', -1);
         }
      }

      for (let hideId of ["openManagmentTool", "embadedManagment", "hybridTool"]) {
         if (document.getElementById(hideId) !== null) {
            document.getElementById(hideId).style.display = 'none';
         }
      }
      window.document.getElementById("performance").style.display = 'none';
      window.position = 'reset';
      window.hotspot = '';

      window.scene._nav._navMaxDolly = 33
      window.scene._nav._panMax = [22, 15];    //[left, bottom];
      window.scene._nav._panMin = [-16, -7];  //[right, top];

      window.scene.groupApplyState("Front_Bezel_ON");
      window.scene.groupApplyState("Internals_OFF");
      window.scene.groupApplyState("Top_cover_ON");
      window.scene.groupApplyState("Ref_Box_A");
      window.scene.animPlayInTime("TOP", 0.0333333, 1);

      document.getElementById('intHeader').style.display = 'none';
      document.getElementById('dm-Enclosure').style.display = 'none';

      window.scene.clearRefine();
   }

   const previousAndNextView = (value) => {
      if (!(mob || isipad)) {
         let previous = document.getElementById('previousView');
         if (previous !== null) {
            previous.setAttribute('aria-label', value);
         }
         let next = document.getElementById('nextView');
         if (next !== null) {
            next.setAttribute('aria-label', value);
         }
      }
   }

   const onExteriorClick = (isNextPrevious) => {
      console.log('onExteriorClick');

      setSelectedButton('onExteriorClick');
      window.selectedButtonGlobal = "onExteriorClick";

      reverseAll();
      if (window.mob || window.isipad) {
         window.scene._nav._navMaxDolly = 70
      } else {
         window.scene._nav._navMaxDolly = 33
      }
      previousAndNextView('Exterior view');

      if (document.getElementById('exteriorViewBtn') !== null) {
         document.getElementById('exteriorViewBtn').classList.add('active');
      }
      window.scene.groupApplyState("Internals_ON");
      window.scene._nav._panMax = [22, 10];    //[left, bottom];
      window.scene._nav._panMin = [-16, -5];  //[right, top];
      GotoPosInTimeNamedValue(window.config.front, function () {
         sliderRangeBarUpdate();
      });

      window.RT_RecordEvent("Exterior", "Exterior View", window.config.name);
      window.scene.clearRefine();
   }

   const FrontModeClick = (isNextPrevious) => {

      console.log('FrontModeClick')

      setSelectedButton('FrontModeClick');
      window.selectedButtonGlobal = "FrontModeClick";

      reverseAll();
      if (window.mob || window.isipad) {
         window.scene._nav._navMaxDolly = 70
      } else {
         window.scene._nav._navMaxDolly = 33
      }
      previousAndNextView('Front view');

      if (document.getElementById('frontBtn') !== null) {
         document.getElementById('frontBtn').classList.add('active');
      }
      window.scene.groupApplyState("Ref_Box_B");
      window.scene.groupApplyState("Internals_ON");
      window.scene.groupApplyState("Front_Bezel_OFF");
      window.scene._nav._panMax = [22, 10];    //[left, bottom];
      window.scene._nav._panMin = [-16, -5];  //[right, top];
      GotoPosInTimeNamedValue(window.config.front, function () {
         sliderRangeBarUpdate();
         window.hotspot = 'front';
      
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         for (let i = 3; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 7) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex', 1);
            }
         }
      }
      window.RT_RecordEvent("Exterior", "Front", window.config.name);
      window.scene.clearRefine();

   }

   const RearModeClick = (isNextPrevious) => {

      console.log('RearModeClick')

      setSelectedButton('RearModeClick');
      window.selectedButtonGlobal = "RearModeClick";

      reverseAll();
      if (window.mob || window.isipad) {
         window.scene._nav._navMaxDolly = 70
      } else {
         window.scene._nav._navMaxDolly = 33
      }
      previousAndNextView('Rear view');

      if (document.getElementById('rearBtn') !== null) {
         document.getElementById('rearBtn').classList.add('active');
      }

      window.scene.groupApplyState("Internals_ON");
      window.scene._nav._panMax = [22, 10];    //[left, bottom];
      window.scene._nav._panMin = [-16, -5];  //[right, top];
      GotoPosInTimeNamedValue(window.config.rear, function () {

         sliderRangeBarUpdate();
         window.hotspot = 'rear';
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         for (let i = 8; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 15) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex', 1);
            }
         }
      }

      window.RT_RecordEvent("Exterior", "Rear", window.config.name);

      window.scene.clearRefine();

   }

   const onInterirorClick = (isNextPrevious) => {

      console.log('onInterirorClick')

      setSelectedButton('onInterirorClick');
      window.selectedButtonGlobal = "onInterirorClick";

      reverseAll();
      window.scene._nav._panMin = [-40, -7];  //[right, top];
      if (window.mob || window.isipad) {
         window.scene._nav._navMaxDolly = 70
      } else {
         window.scene._nav._navMaxDolly = 40
      }

      previousAndNextView('Interior view');

      if (document.getElementById('positionBtn') !== null) {
         document.getElementById('positionBtn').classList.add('active');
      }

      window.scene._nav.tempfRotMinLimit = -0.03;

      window.scene.groupApplyState("Internals_ON");

      GotoPosInTimeNamedValue(window.config.interior, function () {

         window.hotspot = 'interior';
         document.getElementById('intHeader').style.display = 'none';
         window.scene.animPlayInTime("TOP", 0.83330000, animTime, function () {
            window.scene.groupApplyState("Top_cover_OFF");
            sliderRangeBarUpdate();
            window.document.getElementById("performance").style.display = 'block';
            window.scene.clearRefine();
         });

      });

      window.scene.clearRefine();

   }

   const onProcessorClick = (isNextPrevious) => {

      console.log('onProcessorClick')

      setSelectedButton('onProcessorClick');
      window.selectedButtonGlobal = "onProcessorClick";
      window.document.getElementById("performance").style.display = 'none';
      window.scene._nav._panMin = [-40, -7];  //[right, top];
      stopAnim();
      if (window.mob || window.isipad) {
         window.scene._nav._navMaxDolly = 70
      } else {
         window.scene._nav._navMaxDolly = 35
      }
      clearTimeout(clearSlideSetTimeout.current);

      for (let alreadySelected of document.querySelectorAll('.MuiAccordionDetails-root.active,.MuiAccordionDetails-root.select')) {
         if (alreadySelected !== null) {
            alreadySelected.classList.remove('active', 'select');
         }
      }

      for (let hotspot of document.querySelectorAll(".hotspots")) {
         if (hotspot !== null) {
            hotspot.style.display = 'none';
            hotspot.setAttribute('tabindex', -1);
         }
      }

      for (let hideId of ["openManagmentTool", "embadedManagment", "hybridTool"]) {
         if (document.getElementById(hideId) !== null) {
            document.getElementById(hideId).style.display = 'none';
         }
      }
      
      window.position = 'reset';
      window.hotspot = '';
      window.scene.groupApplyState("Front_Bezzel_ON");
      window.scene.groupApplyState("Top_cover_OFF");
      document.getElementById('intHeader').style.display = 'none';
      document.getElementById('dm-Enclosure').style.display = 'none';
      previousAndNextView('Processor');

      if (document.getElementById('processorBtn') !== null) {
         document.getElementById('processorBtn').classList.add('active');
      }

      GotoPosInTimeNamedValue(window.config.processor, function () {
         window.scene.groupApplyState("Heatsink_OFF");
         window.document.getElementById("performance").style.display = 'none';
         window.hotspot = 'processor';
         sliderRangeBarUpdate();
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot19").setAttribute("tabindex", 1);
      }
      window.RT_RecordEvent("Interior", "Processor", window.config.name);
      window.scene.clearRefine();

   }

   const onMemoryClick = (isNextPrevious) => {
      
      setSelectedButton('onMemoryClick');
      window.selectedButtonGlobal = "onMemoryClick";
      reverseAll();
      window.scene._nav._panMin = [-40, -7];  //[right, top];
      if (window.mob || window.isipad) {
         window.scene._nav._navMaxDolly = 70
      } else {
         window.scene._nav._navMaxDolly = 35
      }
      previousAndNextView('Memory');

      if (document.getElementById('memoryBtn') !== null) {
         document.getElementById('memoryBtn').classList.add('active');
      }
      window.scene.groupApplyState("Top_cover_OFF");
      window.scene.groupApplyState("Front_Bezel_OFF");
      window.scene.groupApplyState("Internals_ON");

      GotoPosInTimeNamedValue(window.config.processor, function () {
         sliderRangeBarUpdate();
         window.hotspot = 'memory';
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot20").setAttribute("tabindex", 1);
      }
      window.RT_RecordEvent("Interior", "Memory", window.config.name);

      window.scene.clearRefine();

   }

   const onFanClick = (isNextPrevious) => {
      console.log('onFanClick')
      setSelectedButton('onFanClick');
      window.selectedButtonGlobal = "onFanClick";

      reverseAll();
      if (window.mob || window.isipad) {
         window.scene._nav._navMaxDolly = 70
      } else {
         window.scene._nav._navMaxDolly = 35
      }
      window.scene._nav._panMin = [-40, -7];  //[right, top];
      previousAndNextView('DMEnclosure');

      if (document.getElementById('DMEnclosure') !== null) {
         document.getElementById('DMEnclosure').classList.add('active');
      }
      window.scene.groupApplyState("Internals_ON");
      window.scene.groupApplyState("Front_Bezel_OFF");

      window.scene.groupApplyState("Top_cover_OFF");

      GotoPosInTimeNamedValue(window.config.fans, function () {
         sliderRangeBarUpdate();

         window.hotspot = 'DMEnclosure';
         document.getElementById('dm-Enclosure').style.display = "none"

         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot21").setAttribute("tabindex", 1);
      }
      window.RT_RecordEvent("Interior", "Dynamic Media Enclosure", window.config.name);

      window.scene.clearRefine();

   }

   const onSoftwareClick = (isNextPrevious) => {

      console.log('onSoftwareClick')
      setSelectedButton('onSoftwareClick');
      window.selectedButtonGlobal = "onSoftwareClick";

      reverseAll();
      if (window.mob || window.isipad) {
         window.scene._nav._navMaxDolly = 70
      } else {
         window.scene._nav._navMaxDolly = 33
      }
      window.dellLogoFix = true;
      previousAndNextView('Software');
      if (document.getElementById('feature') !== null) {
         document.getElementById('feature').classList.add('active');
      }

      window.scene.groupApplyState("Internals_ON");
      window.scene._nav._panMax = [22, 10];    //[left, bottom];
      window.scene._nav._panMin = [-16, -5];  //[right, top];
      GotoPosInTimeNamedValue(window.config.front, function () {
         sliderRangeBarUpdate();

         window.hotspot = 'software';
      });

      window.scene.clearRefine();

   }

   const IAutomationClick = (isNextPrevious) => {
      console.log('IAutomationClick')
      setSelectedButton('IAutomationClick');
      window.selectedButtonGlobal = "IAutomationClick";

      reverseAll();
      if (window.mob || window.isipad) {
         window.scene._nav._navMaxDolly = 70
      } else {
         window.scene._nav._navMaxDolly = 33
      }
      previousAndNextView('Intelligent Automation');
      window.scene.groupApplyState("Internals_ON");

      if (document.getElementById('iAutomation') !== null) {
         document.getElementById('iAutomation').classList.add('active');
      }

      GotoPosInTimeNamedValue(window.config.insideSoftware, function () {
         sliderRangeBarUpdate();

         if (window.mob || window.isipad) {
            window.hotspot = 'iAutomation';
         } else {
            document.getElementById("iAutomationTool").style.display = 'block';
         }
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo2").focus();
         }

      });

      if (!(window.isipad || window.mob)) {

         document.getElementById("hotspot1").setAttribute("tabindex", "-1");
         document.getElementById("hotspot2").setAttribute("tabindex", "-1");
         document.getElementById("hotspot3").setAttribute("tabindex", "-1");
         document.getElementById("hotspot4").setAttribute("tabindex", "-1");
         document.getElementById("hotspot5").setAttribute("tabindex", "-1");
         document.getElementById("hotspot6").setAttribute("tabindex", "-1");
         document.getElementById("hotspot7").setAttribute("tabindex", "-1");
         document.getElementById("hotspot8").setAttribute("tabindex", "-1");
         document.getElementById("hotspot9").setAttribute("tabindex", "-1");
         document.getElementById("hotspot10").setAttribute("tabindex", "-1");
         document.getElementById("hotspot11").setAttribute("tabindex", "-1");
         document.getElementById("hotspot12").setAttribute("tabindex", "-1");
         document.getElementById("hotspot13").setAttribute("tabindex", "-1");
         document.getElementById("hotspot14").setAttribute("tabindex", "-1");
         document.getElementById("hotspot15").setAttribute("tabindex", "-1");
         document.getElementById("hotspot16").setAttribute("tabindex", "-1");
         document.getElementById("hotspot17").setAttribute("tabindex", "-1");
         document.getElementById("hotspot18").setAttribute("tabindex", "-1");
         document.getElementById("rLeft").setAttribute("tabindex", "0");
         document.getElementById("rRight").setAttribute("tabindex", "0");
         document.getElementById("zoomOut").setAttribute("tabindex", "0");
         document.getElementById("sliderRange").setAttribute("tabindex", "0");
         document.getElementById("zoomIn").setAttribute("tabindex", "0");
         document.getElementById("previousView").setAttribute("tabindex", "0");
         document.getElementById("resetView").setAttribute("tabindex", "0");
         document.getElementById("nextView").setAttribute("tabindex", "0");

      }

      window.RT_RecordEvent("Software", "Intelligent Automation", window.config.name);

      window.scene.clearRefine();

   }

   const CResiliencyClick = (isNextPrevious) => {
      // console.log('CResiliencyClick')
      setSelectedButton('CResiliencyClick');
      window.selectedButtonGlobal = "CResiliencyClick";

      reverseAll();
      if (window.mob || window.isipad) {
         window.scene._nav._navMaxDolly = 70
      } else {
         window.scene._nav._navMaxDolly = 33
      }
      previousAndNextView('Cyber Resiliency');

      window.scene.groupApplyState("Internals_ON");

      if (document.getElementById('cResiliency') !== null) {
         document.getElementById('cResiliency').classList.add('active');
      }
      GotoPosInTimeNamedValue(window.config.insideSoftware, function () {

         sliderRangeBarUpdate();
         (window.mob || window.isipad) && (window.hotspot = 'cResiliency');
         !(window.mob || window.isipad) && (document.getElementById("cResiliencyTool").style.display = 'block')

         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo2").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex", "-1");
         document.getElementById("hotspot2").setAttribute("tabindex", "-1");
         document.getElementById("hotspot3").setAttribute("tabindex", "-1");
         document.getElementById("hotspot4").setAttribute("tabindex", "-1");
         document.getElementById("hotspot5").setAttribute("tabindex", "-1");
         document.getElementById("hotspot6").setAttribute("tabindex", "-1");
         document.getElementById("hotspot7").setAttribute("tabindex", "-1");
         document.getElementById("hotspot8").setAttribute("tabindex", "-1");
         document.getElementById("hotspot9").setAttribute("tabindex", "-1");
         document.getElementById("hotspot10").setAttribute("tabindex", "-1");
         document.getElementById("hotspot11").setAttribute("tabindex", "-1");
         document.getElementById("hotspot12").setAttribute("tabindex", "-1");
         document.getElementById("hotspot13").setAttribute("tabindex", "-1");
         document.getElementById("hotspot14").setAttribute("tabindex", "-1");
         document.getElementById("hotspot15").setAttribute("tabindex", "-1");
         document.getElementById("hotspot16").setAttribute("tabindex", "-1");
         document.getElementById("hotspot17").setAttribute("tabindex", "-1");
         document.getElementById("hotspot18").setAttribute("tabindex", "-1");

         document.getElementById("rLeft").setAttribute("tabindex", "0");
         document.getElementById("rRight").setAttribute("tabindex", "0");
         document.getElementById("zoomOut").setAttribute("tabindex", "0");
         document.getElementById("sliderRange").setAttribute("tabindex", "0");
         document.getElementById("zoomIn").setAttribute("tabindex", "0");
         document.getElementById("previousView").setAttribute("tabindex", "0");
         document.getElementById("resetView").setAttribute("tabindex", "0");
         document.getElementById("nextView").setAttribute("tabindex", "0");
      }
      window.RT_RecordEvent("Software", "Cyber Resiliency", window.config.name);
      window.scene.clearRefine();
   }

   const resetMode = () => {
      setSelectedButton('onResetMode');
      window.selectedButtonGlobal = "onResetMode";
      window.hotspot = '';
      GotoPosInTimeNamedValue(window.config.reset);
   }

   const menuSelectedButton = (menuSelectItem, expandedPanel = false) => {
      if (menuSelectItem === 'onExteriorClick') {
         expandedPanel && setExpandedPanel("panel2");
         onExteriorClick(true);
      }
      else if (menuSelectItem === 'FrontModeClick') {
         expandedPanel && setExpandedPanel("panel2");
         FrontModeClick(true);
      }
      else if (menuSelectItem === 'RearModeClick') {
         expandedPanel && setExpandedPanel("panel2");
         RearModeClick(true);
      }
      else if (menuSelectItem === 'onInterirorClick') {
         expandedPanel && setExpandedPanel("panel5");
         onInterirorClick(true);
      }
      else if (menuSelectItem === 'onProcessorClick') {
         expandedPanel && setExpandedPanel("panel5");
         onProcessorClick(true);
      }
      else if (menuSelectItem === 'onMemoryClick') {
         expandedPanel && setExpandedPanel("panel5");
         onMemoryClick(true);
      }
      else if (menuSelectItem === 'onFanClick') {
         expandedPanel && setExpandedPanel("panel5");
         onFanClick(true);
      }
      else if (menuSelectItem === 'onSoftwareClick') {
         expandedPanel && setExpandedPanel("panel3");
         onSoftwareClick(true);
      }
      else if (menuSelectItem === 'IAutomationClick') {
         expandedPanel && setExpandedPanel("panel3");
         IAutomationClick(true);
      }
      else if (menuSelectItem === 'CResiliencyClick') {
         expandedPanel && setExpandedPanel("panel3");
         CResiliencyClick();
      }

      else if (menuSelectItem === 'onResetMode') {
         resetMode();
      }
   }

   const onResetMode = () => {
      /* { Zoombar update } */
      sliderRangeBarUpdate();
      menuSelectedButton(window.selectedButtonGlobal, false);
      window.scene.clearRefine();
   }

   const onPreviousMode = () => {
      sliderRangeBarUpdate();
      if (document.getElementById("bEfficiencyTool") !== null) {
         document.getElementById("bEfficiencyTool").style.display = 'none';
      }
      if (document.getElementById("iAutomationTool") !== null) {
         document.getElementById("iAutomationTool").style.display = 'none';
      }
      if (document.getElementById("cResiliencyTool") !== null) {
         document.getElementById("cResiliencyTool").style.display = 'none';
      }
      var prevButton;

      var selectedButtonIndex = buttonSeq.findIndex(element => element === window.selectedButtonGlobal)
      if (window.selectedButtonGlobal === 'onExteriorClick' || window.selectedButtonGlobal === 'onResetMode') {
         prevButton = 'CResiliencyClick';
      } else {
         prevButton = buttonSeq[selectedButtonIndex - 1];
      }

      menuSelectedButton(prevButton, true);

      return false;
   }

   const onNextMode = () => {
      sliderRangeBarUpdate();
      if (document.getElementById("bEfficiencyTool") !== null) {
         document.getElementById("bEfficiencyTool").style.display = 'none';
      }
      if (document.getElementById("iAutomationTool") !== null) {
         document.getElementById("iAutomationTool").style.display = 'none';
      }
      if (document.getElementById("cResiliencyTool") !== null) {
         document.getElementById("cResiliencyTool").style.display = 'none';
      }
      var nextButton;
      var selectedButtonIndex = buttonSeq.findIndex(element => element === window.selectedButtonGlobal)
      if (window.selectedButtonGlobal === 'CResiliencyClick') {
         nextButton = 'onExteriorClick';
      }
      else {
         nextButton = buttonSeq[selectedButtonIndex + 1];
      }
      menuSelectedButton(nextButton, true);

      return false;
   }
   const [animValue, setAnimValue] = useState("On");

   const [animValue1, setAnimValue1] = useState("On");

   useEffect(() => {
      window.Animation = 'on';
      setAnimValue("On");
      document.getElementById("animSwitchValue").checked = true;
      document.getElementsByClassName('onOff')[0].style.left = "-17px";

      if (!(window.mob && window.innerWidth < window.innerHeight)) {
         document.getElementById("animSwitchValue1").setAttribute('aria-label', 'Animation On');
         setAnimValue1("On");
         document.getElementById("animSwitchValue1").checked = true;
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
      }

      return () => {
         return false
      }
   }, []);

   const setAnimationSwitch = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         document.getElementById("animSwitchValue").checked = false;
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.Animation = 'off';

      } else {
         document.getElementById("animSwitchValue").checked = true;
         setAnimValue("On");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";

      }
   }
   const displayName = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         setAnimValue("On");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         document.getElementById('animSwitchValue').setAttribute('aria-label', 'clickable checkbox checked On');

      } else {
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.Animation = 'off';
         document.getElementById('animSwitchValue').setAttribute('aria-label', 'clickable checkbox checked Off');
      }

   }
   const setAnimationSwitch1 = (e) => {

      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         document.getElementById("animSwitchValue1").checked = false;
         setAnimValue1("Off");
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animationSwitchVal = 'off';
         window.animationSwitchGlobal = 'off';
      }
      else {
         document.getElementById("animSwitchValue1").checked = true;
         setAnimValue1("On");
         window.animationSwitchVal = 'on';
         window.animationSwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
      }
   }
   var animStopped = true;
   const displayName1 = (e) => {
      if (animStopped == false) {
         return;
         animStopped = false;
      }
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         setAnimValue1("On");
         window.animation1SwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
         document.getElementById('animSwitchValue1').setAttribute('aria-label', 'clickable checkbox checked On');
         window.animationSwitchVal = 'on';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'block';
         }
         else if (window.isipad) {
            document.getElementById('footerControMob').style.display = 'block';
            document.getElementById('footerControls').style.display = 'block';
         }
         else {

            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "20px";

            document.getElementById('footerControls').style.visibility = "";
            document.getElementById('footerControIpad').style.visibility = "";
         }


      } else {
         setAnimValue1("Off");
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animation1SwitchGlobal = 'off';

         document.getElementById('animSwitchValue1').setAttribute('aria-label', 'clickable checkbox checked Off');

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'none';
         } else if (window.isipad) {
            document.getElementById('footerControMob').style.display = 'none';
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "-118px";
            setTimeout(function () {

               document.getElementById('footerControls').style.visibility = "hidden";
               document.getElementById('footerControIpad').style.visibility = "hidden";
               animStopped = true;
            }, 200);
         }

      }

   }
   return (
      <>
         {!mob && <HowToUse />}
         <Hidden only={['sm', 'md', 'lg', 'xl']}>

            <Button style={{ position: 'fixed', backgroundColor: '#F0F0F0', width: '100%', height: '56px', paddingTop: '15px', paddingBottom: '15px', zIndex: '1', border: '1px solid #E1E1E1', borderLeft: "none", borderRight: "none", borderRadius: "0", margin: "-1px 0px 0px 0px" }}
               variant="outlined"
               color="primary"
               endIcon={<img src="./img/cross.svg" alt="cross" style={{ marginLeft: '207px', height: '23px' }} />}
               onClick={props.toggleDrawerAction}
            >
               Main Menu
            </Button>
            <Howtousenew />

         </Hidden>
         <Hidden only={['md', 'lg', 'xl', 'xs']}>
            {moblandscap && <Howtousenew />}
         </Hidden>

         <Hidden only={["xs"]}>
            <FooterControl name="reset and next previous" onReset={onResetMode} onPrevious={onPreviousMode} onNext={onNextMode} />
         </Hidden>
         <Hidden only={['lg', 'xl']}>
            <FooterControlMob onResetMob={onResetMode} onPreviousMob={onPreviousMode} onNextMob={onNextMode} onResetIpad={onResetMode} onNextIpad={onNextMode} onPreviousIpad={onPreviousMode} />
         </Hidden>

         <MenuExteriorView name={window.finalLangues.port2} tabIndex="1" onExterior={onExteriorClick} onFrontMode={FrontModeClick} onRearMode={RearModeClick} expanded={expandedPanel === 'panel2'} onChanged={handleAccordionChange('panel2')} />

         <MenuInterierView name={window.finalLangues.port3} tabIndex="1" onProcessorBtnClick={onProcessorClick} onMemoryBtnClick={onMemoryClick} onDMEnclosureClick={onFanClick} onInterirorBtnClick={onInterirorClick} expanded={expandedPanel === 'panel5'} onChanged={handleAccordionChange('panel5')} />

         <MenuSoftware name={window.finalLangues.port4} tabIndex="1" onIAutomationClicked={IAutomationClick} onCResiliencyClicked={CResiliencyClick} onSoftware={onSoftwareClick} expanded={expandedPanel === 'panel3'} onChanged={handleAccordionChange('panel3')} />

         <AnimationBtn onchange={displayName} forKeypress={setAnimationSwitch} value={animValue} onchange1={displayName1} forKeypress1={setAnimationSwitch1} value1={animValue1} />

      </>
   );
}

export default MainMenu;